// extracted by mini-css-extract-plugin
export default {"wrap":"cH-z","articleImagesWrap":"dH-z","articleImage":"eH-z","singleImage":"fH-z"};